import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, TextField, Button, Box, Grid, IconButton, Card, CardContent, MenuItem, Select, Divider,
  InputAdornment, Alert
} from '@mui/material';
import { useSelector } from 'react-redux';
import colors from "assets/mavric-theme/base/colors.js";
import Typography from '@mui/material/Typography';
import typography from "assets/mavric-theme/base/typography";
// import AddUserBgImg from "../../assets/img/add_customer.png";
import { addNewCustomer } from "apis/CustomersApis";
import Switch from '@mui/material/Switch';
import borders from "assets/mavric-theme/base/borders";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PasswordStrengthBar from 'react-password-strength-bar';
const { borderRadius } = borders;
const { primary, secondary, text, transparent } = colors;
const { size } = typography;

import { getUserRoles } from "apis/CustomersApis";
import { getKeyValue, digestMessage, hasKeyName, isEmptyObject, validateName, validateEmail, removeAllSpaces, toPascalCase } from "common_utils/utils";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/material.css';
import outlined from 'assets/mavric-theme/components/button/outlined';
import { boxShadow } from 'assets/jss/material-dashboard-react';

export default function AddCustomerDialog({ open, getBilledCustomersData, getDemoCustomersData, handleClose, userRole }) {

  const UserId = useSelector(state => state.userid);
  const RoleId = useSelector(state => state.roleId);
  const Token = useSelector(state => state.accessToken);
  const [isValid, setIsValid] = useState(false);
  // const [ssoAuthProvider, setSsoAuthProvider] = useState(authProviderList[0].auth_provider);
  // const [enabledSsoAuth, setEnabledSsoAuth] = useState(false);
  const [formData, setFormData] = useState({
    org_name: '',
    product_type: 1,
    act_type: userRole === 'accounting' ? 'billed' : 'demo'
  });

  const initialUserInfo = {
    user_id: 0, role_name: "", role_id: 1, email: "", password: "", first_name: "", last_name: "", phone: "",
    mosaic_view_enabled: true, num_probes: 1, num_views: 1, num_vms: 2, lic_ref_value: ""
  };
  const [userInfo, setUserInfo] = useState(initialUserInfo);
  const [usrFName, setUsrFName] = useState(userInfo.first_name);
  const [usrLName, setUsrLName] = useState(userInfo.last_name);
  const [usrPhoneNumber, setUsrPhoneNumber] = useState(userInfo.phone);
  const [usrRoleId, setUsrRoleId] = useState(userInfo.role_id);
  const [usrRoleName, setUsrRoleName] = useState(userInfo.role_name);
  const [usrEmail, setEmailAddr] = useState(userInfo.email);
  const [enabledMosaicView, setEnabledMosaicView] = useState(true);
  const [enabledIOMatrixSwitch, setEnabledIOMatrixSwitch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [userPassword, setPassword] = useState("");
  const [userRoleList, setUserRoleList] = useState([]);
  const [enableActionBtn, setEnableActionBtn] = useState(false);
  const [compError, setError] = useState("");
  const MAX_NUM_VIEWS = 200;
  const [licStartDt, setLicStartDt] = useState(new Date());
  const [licEndDt, setLicEndDt] = useState(new Date());
  const [numProbes, setNumProbes] = useState(userInfo.num_probes);
  const [numViews, setNumViews] = useState(userInfo.num_views);
  const [numVms, setNumVms] = useState(userInfo.num_vms);
  // const [numConfUsers, setNumConfUsers] = useState(userInfo.num_conf_users);
  const [licNote, setLicNote] = useState(userInfo.lic_ref_value);
  // const checkValidity = () => {
  //   if (customerName.trim() !== '' && productType !== '') {
  //     setIsValid(true);
  //   } else {
  //     setIsValid(false);
  //   }
  // };

  const checkValidity = () => {
    const { org_name, product_type } = formData;
    setIsValid(org_name.trim() !== '' && product_type !== null);
  };

  // Update default dates when customerType changes
  useEffect(() => {
    const { licStartDt, licEndDt } = getDefaultDates(formData.act_type);
    setLicStartDt(licStartDt);
    setLicEndDt(licEndDt);
  }, [formData.act_type]);

  useEffect(() => {
    checkValidity();
    checkDateValidity();
  }, [formData, licStartDt, licEndDt]);

  useEffect(() => {
  }, [usrFName, usrEmail, usrLName, userInfo, userPassword, usrRoleId, licNote, numProbes, numViews]);

  useEffect(() => {
    getUserRolesData();
  }, []);

  const onChangeEnableMosaicView = (e) => {
    let isChecked = e.target.checked;
    setError(null);
    setEnabledMosaicView(isChecked);
  }

  const onChangeEnableIOMatrixSwitch = (event) => {
    setEnabledIOMatrixSwitch(event.target.checked);
  };

  const getDefaultDates = (customerType) => {
    const today = new Date();
    let expiration = new Date(today);

    if (customerType === 'billed') {
      expiration.setFullYear(today.getFullYear() + 1);
    } else if (customerType === 'demo') {
      expiration.setMonth(today.getMonth() + 3);
    }

    return {
      licStartDt: today,
      licEndDt: expiration
    };
  };

  const getUserRolesData = () => {
    // console.log("Token::", Token);
    return new Promise(function (resolve, reject) {
      getUserRoles().then((response) => {
        //   console.log("getUserRolesData: ", response);
        setUserRoleList(response);
        resolve(response);
      }).catch((error) => {
        setUserRoleList([]);
        let errMessage = '';

        if (error.response) {
          errMessage = error.response.data.message;
          if (error.response.status === 401 || error.response.status === 403) {
            let jsonPostMsg = { "user_id": UserId, "access_token": Token, "role_id": RoleId };
            dispatch(logout(jsonPostMsg));
            history.push('/login');
          }
        } else if (error.request) {
          errMessage = `${error}`;
          // The request was made but no response was received
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
          errMessage = error.message;
        }
        reject(errMessage);
      });
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("input changes for product type:", e.target.value);
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));


    // setError(null);
    switch (e.target.name) {
      case 'usrEmail':
        let usrEmail = e.target.value;
        usrEmail = removeAllSpaces(usrEmail)
        setEmailAddr(usrEmail);
        userInfo.email = usrEmail;
        setUserInfo(userInfo);
        break;
      case 'usrFName':
        let usrFName = e.target.value;
        usrFName = removeAllSpaces(usrFName)
        setUsrFName(usrFName);
        userInfo.first_name = usrFName;
        setUserInfo(userInfo);
        break;
      case 'usrLName':
        let usrLName = e.target.value;
        usrLName = removeAllSpaces(usrLName);
        setUsrLName(usrLName);
        userInfo.last_name = usrLName;
        setUserInfo(userInfo);
        break;
      case 'usrPhoneNumber':
        let usrPhoneNumber = e.target.value;
        usrPhoneNumber = removeAllSpaces(usrPhoneNumber);
        setUsrPhoneNumber(usrPhoneNumber);
        userInfo.phone = usrPhoneNumber;
        setUserInfo(userInfo);
        break;
      case 'num_probes':
        let num_probes = e.target.value != null ? e.target.value : numProbes;
        setNumProbes(num_probes);
        userInfo.num_probes = num_probes;
        setUserInfo(userInfo);
        break;
      case 'num_views':
        let num_views = e.target.value != null ? e.target.value : numViews;
        setNumViews(num_views);
        userInfo.num_views = num_views;
        setUserInfo(userInfo);
        break;
      // case 'num_conf_users':
      //   let num_conf_users = e.target.value != null ? e.target.value : numConfUsers;
      //   setNumConfUsers(num_conf_users);
      //   userInfo.num_conf_users = num_conf_users;
      //   setUserInfo(userInfo);
      //   break;
      case 'num_vms':
        let num_vms = e.target.value != null ? e.target.value : numVms;
        setNumVms(num_vms);
        userInfo.num_vms = num_vms;
        setUserInfo(userInfo);
        break;
      case 'lic_ref_value':
        let lic_ref_value = e.target.value;
        usrLName = removeAllSpaces(lic_ref_value);
        setLicNote(lic_ref_value);
        userInfo.last_name = lic_ref_value;
        setUserInfo(userInfo);
        break;
    }

    checkForm(userInfo);
  };


  const handlePhoneChange = (value) => {
    let usrPhoneNumber = removeAllSpaces("+" + value);
    //console.log(usrPhoneNumber);
    setUsrPhoneNumber(usrPhoneNumber);
    userInfo.phone = usrPhoneNumber;
    setUserInfo(userInfo);
    checkForm(userInfo);
  };


  const validateForm = (userInfo) => {

    if (!(hasKeyName(userInfo, "first_name") &&
      hasKeyName(userInfo, "last_name") &&
      hasKeyName(userInfo, "email") &&
      hasKeyName(userInfo, "role_id") &&
      hasKeyName(userInfo, "password") &&
      hasKeyName(userInfo, "customer_id") &&
      hasKeyName(userInfo, "mosaic_view_enabled") &&
      hasKeyName(userInfo, "num_probes") &&
      hasKeyName(userInfo, "num_views") &&
      hasKeyName(userInfo, "num_vms") &&
      hasKeyName(userInfo, "num_conf_users") &&
      hasKeyName(userInfo, "lic_ref_value")) &&
      hasKeyName(formData, "org_name")
    ) return false;

    if (isEmptyObject(userInfo.password) || isEmptyObject(userInfo.email) || (isEmptyObject(formData.org_name))) return false;

    return validateEmail(userInfo.email);

  };

  const isValidDate = (dateString) => {
    // Expected string format yyyy-mm-dd
    //if ( dateString === null || dateString.trim() === "" || dateString.length != 10) return false;
    //if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return false;

    const parts = dateString.split("-");
    const dateYear = parseInt(parts[0], 10);
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    if (dateYear < (currentYear - 1)) return false;

    const date = new Date(dateString);
    return !isNaN(date) && date.toString() !== 'Invalid Date';
  }

  const handleSubmit = async (event) => {
    let newUserInfo;
    let licensesObject = null;

    newUserInfo = {
      email: usrEmail,
      mosaic_view_enabled: enabledMosaicView,
      iomatrix_switch_enabled: enabledIOMatrixSwitch,
      role_id: usrRoleId,
      password: userPassword,
      phone: usrPhoneNumber,
      first_name: usrFName,
      role_name: usrRoleName,
      last_name: usrLName,
    }
    console.log("newUserInfo::", newUserInfo);

    // let numProbes = parseInt(getKeyValue(formData, "num_probes", 0));
    // let numViews = parseInt(getKeyValue(formData, "num_views", 0));
    // let numConfUsrs = parseInt(getKeyValue(formData, "num_conf_users", 0));
    // let licRefValue = getKeyValue(formData, "lic_ref_value", "");


    if (((numProbes >= 0) && (numProbes <= MAX_NUM_VIEWS)) &&
      // ((numConfUsers >= 0) && (numConfUsers <= MAX_NUM_VIEWS)) &&
      ((numViews >= 0) && (numViews <= MAX_NUM_VIEWS))
      // && ((numMosaicViews > 0) && (numMosaicViews <= MAX_NUM_VIEWS))
    ) {
      licensesObject = {
        num_probes: parseInt(numProbes),
        num_views: parseInt(numViews),
        // num_conf_users: parseInt(numConfUsers),
        lic_ref_value: licNote.trim(),
        // lic_start: new Date(licStartDt).toISOString(),
        // lic_end: new Date(licEndDt).toISOString(),
        lic_start: licStartDt,
        lic_end: licEndDt,
      };

      if (formData.product_type === "2" || formData.product_type === "mavric-cloud-onprem" || formData.product_type === "mavric-monitoring-onprem") {
        licensesObject.num_vms = numVms ? parseInt(numVms) : 2;
        licensesObject.set_num_vms = true;
      } else {
        licensesObject.set_num_vms = false;
      }
    }


    event.preventDefault();
    if (!isValid && !validateForm) setError("Form validation failed. Please check the values before submitting.");
    try {

      const payload = {
        org_name: formData.org_name,
        product_id: parseInt(formData.product_type),
        act_type: formData.act_type,
        add_users: [newUserInfo],
        license_details: licensesObject
      };
      // console.log("Payload::", payload);
      digestMessage(userPassword).then(async newHashPswd => {
        try {
          newUserInfo.password = newHashPswd;
          let response = await addNewCustomer(payload);
          console.log(response.payload, response);
          if (response != null) {
            if (formData.act_type === 'billed') {
              await getBilledCustomersData();
            } else if (formData.act_type === 'demo') {
              await getDemoCustomersData();
            }
            handleConfirmClose();
          }
        } catch (error) {
          console.error("Error hashing password:", error);
          if (error.response && error.response.data && error.response.data.message) {
            const errorMessage = error.response.data.message;
            if (errorMessage.includes("Customer with orgname already exists")) {
              setError("Customer with organization name already exists. Please choose a different organization name.");
            } else if (errorMessage.includes("User with email already exists")) {
              setError("User with email already exists. Please choose a different email.");
            } else {
              setError(`Error: ${errorMessage}`);
            }
          }
        }
      });
      // resetForm();
      // handleConfirmClose();
      // let response = await addNewCustomer(payload);
      // const customerId = response.customer_id;
      // if (enabledSsoAuth){
      //     let identityProvider = IdentityProviders[ssoAuthProvider];        
      //     response = await updateAuthProviderByCustomerId(customerId, ssoAuthProvider, identityProvider);
      // }        
      // await getCustomerData();
      // await getLicensesData();
      // await getAuthProviderData();

    } catch (error) {
      console.error("Error adding customer:", error);
      setError("Form validation failed. Please check the values before submitting.");
    }
    // console.log('Form submitted with:', { customerName, productType });
    // setCustomerName("");
    // setProductType("");
  };

  const resetForm = () => {
    setFormData({
      org_name: '',
      product_type: 1,
      act_type: userRole === 'accounting' ? 'billed' : 'demo'
    });
  };

  const checkForm = (userInfo) => {
    setEnableActionBtn((validateEmail(userInfo.email) && (userPassword.length > 3)));
  }

  const handleTogglePassword = () => setShowPassword(showPassword => !showPassword);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setError(null);
    checkForm(userInfo);
  };

  const handleRoleChange = (event) => {
    setUsrRoleId(event.target.value);
    const role = userRoleList.find(role => role.id === event.target.value);
    // console.log("handleRoleChange::", role, role.role);
    setUsrRoleName(role.role);
  }

  // const checkDateValidity = () => {
  //     if (isValidDate(licStartDt.trim()) && isValidDate(licEndDt.trim())) {
  //         setIsValid(new Date(licStartDt.trim()) <= new Date(licEndDt.trim()));
  //     } else {
  //         setIsValid(false);
  //     }
  // };
  const checkDateValidity = () => {
    if (licStartDt && licEndDt) {
      setIsValid(licStartDt <= licEndDt);
    } else {
      setIsValid(false);
    }
  };

  const handleConfirmClose = () => {
    setUserInfo(initialUserInfo);
    // setFormData("");
    setUsrFName("");
    setUsrLName("");
    setEmailAddr("");
    setPassword("");
    setUsrPhoneNumber("");
    setEnabledMosaicView(true);
    setEnabledIOMatrixSwitch(true);
    setUsrRoleId(1);
    setNumProbes(1);
    setEnableActionBtn(false);
    // setNumConfUsers(1);
    setNumViews(1);
    setNumVms(2);
    setLicNote("");
    setError("");
    resetForm();
    handleClose();
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose} maxWidth="lg" sx={{ '& .MuiDialog-paper': { backgroundColor: primary.main } }}>
        {/* <DialogTitle>
          <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, m:0, p:0 }}> Add New Customer </Typography>
        </DialogTitle> */}
        <DialogContent>
          <Grid container direction="column" justifyContent="center" alignItems="center">
            <Grid item>
              <Card>
                <CardContent>
                  <form onSubmit={handleSubmit}>
                    <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, marginBottom: '8px' }} >
                      New Customer Details
                    </Typography>
                    <Grid container direction="row" spacing={2} justifyContent="center" alignItems="center">
                      {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Box
                          component="img"
                          alt="AddUserBgImg"
                          src={AddUserBgImg}
                          justifyContent="center"
                          width={150}
                        />
                      </Grid> */}
                      <Grid item xs={12} sm={4} md={4} lg={4} >
                        <Typography fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                          Customer Name*
                        </Typography>
                        <TextField
                          sx={{ width: 300 }}
                          id="customerName"
                          name="org_name"
                          placeholder="Enter Customer Name"
                          autoComplete='off'
                          value={formData.org_name}
                          // onChange={(e) => setCustomerName(e.target.value)}
                          onChange={handleChange}
                          variant="outlined"
                          InputProps={{
                            sx: {
                              paddingLeft: 0.5,
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={4} >
                        <Typography fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                          Mavric Product Type*
                        </Typography>
                        <Select
                          sx={{
                            width: 300,
                            '.MuiSelect-select': {
                              paddingTop: '8px !important',
                              paddingBottom: '8px !important',
                              minHeight: '35px !important',
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '1em !important'
                            },
                          }}
                          id="productType"
                          name="product_type"
                          // name="productType"
                          value={formData.product_type}
                          // onChange={(e) => setProductType(e.target.value)}
                          onChange={handleChange}

                        >
                          {/* <MenuItem value="" disabled>Select Product Type</MenuItem> */}
                          <MenuItem value="1">mavric-cloud</MenuItem>
                          <MenuItem value="2">mavric-cloud-onprem</MenuItem>
                        </Select>
                      </Grid>

                      {/* Account Type Field (only visible to accounting) */}
                      {/* {userRole === 'accounting' && ( */}
                      <Grid item xs={12} sm={4} md={4} lg={4} >
                        <Typography fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 600 }}>
                          Account Type*
                        </Typography>
                        <Select
                          sx={{
                            width: 300,
                            '.MuiSelect-select': {
                              paddingTop: '8px !important',
                              paddingBottom: '8px !important',
                              minHeight: '35px !important',
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '1em !important'
                            },
                          }}
                          name="act_type"
                          value={formData.act_type}
                          // value={"demo"}
                          onChange={handleChange}
                        >
                          <MenuItem value="billed">Billed</MenuItem>
                          <MenuItem value="demo">Demo</MenuItem>
                        </Select>
                      </Grid>
                      {/* )} */}
                    </Grid>

                    <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />
                    <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, marginBottom: '8px' }} >
                      New User Details
                    </Typography>
                    <Grid container spacing={2} direction="row">
                      <Grid item xs={12} sm={4} md={4} lg={4} >
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          First Name
                        </Typography>
                        <TextField
                          id='txtFldUsrFName'
                          name='usrFName'
                          placeholder='First Name'
                          value={usrFName !== null && usrFName !== undefined ? usrFName : ''}
                          onChange={handleChange}
                          fullWidth
                          type={'text'}
                          InputProps={{ readOnly: false, sx: { color: text.main } }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4} >
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          Last Name
                        </Typography>
                        <TextField
                          id='txtFldUsrLName'
                          name='usrLName'
                          placeholder='Last Name'
                          value={usrLName !== null && usrLName !== undefined ? usrLName : ''}
                          onChange={handleChange}
                          fullWidth
                          type={'text'}
                          InputProps={{ readOnly: false, sx: { color: text.main } }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{ sx: { color: text.main }, }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4} >

                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          Email Address*
                        </Typography>
                        <TextField
                          required
                          id={`txtFldUsrEmail`}
                          name="usrEmail"
                          value={usrEmail}
                          onChange={handleChange}
                          fullWidth
                          autoComplete="off"
                          InputProps={{ readOnly: false, sx: { color: text.main } }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          placeholder="Email Address"
                          InputLabelProps={{ sx: { color: text.main }, }}
                        />
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={secondary.main} sx={{ fontWeight: 400, }}>Note: This will be the user's Login Id.</Typography>
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }}>
                          Phone Number
                        </Typography>
                        <PhoneInput
                          id={`txtFldUsrPhoneNumber`}
                          name="usrPhoneNumber"
                          value={usrPhoneNumber}
                          onChange={handlePhoneChange}
                          fullWidth
                          dropdownStyle={{ margin: '0px', backgroundColor: "primary.focus" }}
                          country={'us'}
                          specialLabel=''
                          autoComplete="off"
                          InputProps={{ readOnly: false, sx: { color: text.main } }}
                          sx={{
                            color: text.main,
                            borderColor: primary.focus,
                            backgroundColor: transparent.main,
                            borderRadius: borderRadius.md
                          }}
                          placeholder="Enter phone number"
                          InputLabelProps={{ sx: { color: text.main } }}
                          inputStyle={{ width: '100%', height: '50px', backgroundColor: '#EFEFEF', color: text.main, border: 'none', boxShadow: 'none', outline: 'none' }}
                        />
                      </Grid>

                      {/* Role Type */}
                      <Grid item xs={12} sm={4}>
                        <Typography variant="body2" color={text.main} fontSize={size.xs} sx={{ fontWeight: 400, marginBottom: '8px' }}>
                          Role Type
                        </Typography>
                        <Select
                          id="usrRoleId"
                          name="usrRoleId"
                          value={usrRoleId}
                          onChange={handleRoleChange}
                          displayEmpty
                          fullWidth
                          sx={{
                            '.MuiSelect-select': {
                              paddingTop: '8px !important',
                              paddingBottom: '8px !important',
                              minHeight: '35px !important',
                              display: 'flex',
                              alignItems: 'center',
                              fontSize: '1em !important'
                            }
                          }}
                        >
                          {userRoleList.map((item, idx) => (
                            <MenuItem key={idx} value={item.id}>
                              {toPascalCase(item.role)}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4} >
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          Password*
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          id="filled-password-input"
                          name="usrPassword"
                          type={showPassword ? "text" : "password"}
                          variant="outlined"
                          onChange={handlePasswordChange}
                          // sx={{ width: 300 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={handleTogglePassword}
                                  edge="end"
                                >
                                  {showPassword ? <VisibilityOffIcon color="secondary" /> : <VisibilityIcon color="secondary" />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          size="small"
                          // sx={{ width: 200}}
                          placeholder="Password"
                        />
                        <PasswordStrengthBar password={userPassword} />

                      </Grid>

                      <Grid item xs={12} sm={4} >
                        <Typography
                          variant="body2"
                          fontSize={size.xs}
                          color={text.main}
                          sx={{ fontWeight: 400, marginBottom: '8px' }}
                        >
                          Mosaic View
                        </Typography>

                        <Grid container direction="row" alignItems="center">
                          <Grid item>
                            <Switch
                              name="chkUsrMosaicView"
                              checked={enabledMosaicView}
                              onChange={onChangeEnableMosaicView}
                              inputProps={{ 'aria-label': 'controlled' }}
                              sx={{ ml: "-10px" }}
                            />
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="body2"
                              fontSize={size.sm}
                              color={text.main}
                              sx={{ fontWeight: 400, marginTop: '4px' }}
                            >
                              {enabledMosaicView ? 'Enable' : 'Disable'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} sm={4}>
                        <Typography
                          variant="body2"
                          fontSize={size.xs}
                          color={text.main}
                          sx={{ fontWeight: 400, marginBottom: '8px' }}
                        >
                          Preset Switch
                        </Typography>

                        <Grid container direction="row" alignItems="center">
                          <Grid item>
                            <Switch
                              name="chkUsrIOMatrixSwitch"
                              checked={enabledIOMatrixSwitch}
                              onChange={onChangeEnableIOMatrixSwitch}
                              inputProps={{ 'aria-label': 'controlled' }}
                              sx={{ ml: "-10px" }}
                            />
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="body2"
                              fontSize={size.sm}
                              color={text.main}
                              sx={{ fontWeight: 400, marginTop: '4px' }}
                            >
                              {enabledIOMatrixSwitch ? 'Enable' : 'Disable'}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                    </Grid>

                    <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />
                    <Typography variant="body2" fontSize={size.md} justifyContent="center" color={text.main} sx={{ fontWeight: 600, marginBottom: '8px' }} >
                      License Details
                    </Typography>
                    <Grid container spacing={2} direction="row">
                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          No. of Probes
                        </Typography>
                        <TextField
                          id='txtFldnum_probes'
                          name='num_probes'
                          placeholder='No. of Probes'
                          value={numProbes}
                          onChange={handleChange}
                          fullWidth
                          type={'number'}
                          InputProps={{
                            // readOnly: column.accessorKey === 'org_name',
                            sx: { color: text.main },
                            inputProps: {
                              min: 0,
                              max: 200,
                            },
                          }}
                          // InputProps={{  readOnly: false, sx: { color: text.main },inputProps: {  min: 1,max: 200, },  }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          No. of Views
                        </Typography>
                        <TextField
                          id='txtFldnum_views'
                          name='num_views'
                          placeholder='No. of Views'
                          value={numViews}
                          onChange={handleChange}
                          fullWidth
                          type={'number'}
                          InputProps={{
                            // readOnly: column.accessorKey === 'org_name',
                            sx: { color: text.main },
                            inputProps: {
                              min: 0,
                              max: 200,
                            },
                          }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid>

                      {formData.product_type === "2" && (
                        <Grid item xs={12} sm={4} md={4} lg={4}>
                          <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                            No. of VMs
                          </Typography>
                          <TextField
                            id='txtFldnum_vms'
                            name='num_vms'
                            placeholder='No. of VMs'
                            value={formData.num_vms || 2}
                            onChange={handleChange}
                            fullWidth
                            type={'number'}
                            InputProps={{
                              sx: { color: text.main },
                              inputProps: {
                                min: 1,
                                max: 50,
                              },
                            }}
                            sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                            InputLabelProps={{
                              sx: { color: text.main },
                            }}
                          />
                        </Grid>
                      )}

                      {/* <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          No. of Conf Users
                        </Typography>
                        <TextField
                          id='txtFldnum_conf_users'
                          name='num_conf_users'
                          placeholder='No. of Conf Users'
                          value={numConfUsers}
                          onChange={handleChange}
                          fullWidth
                          type={'number'}
                          InputProps={{
                            // readOnly: column.accessorKey === 'org_name',
                            sx: { color: text.main },
                            inputProps: {
                              min: 0,
                              max: 200,
                            },
                          }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid> */}
                      {/* </Grid> */}
                      {/* <br /> */}
                      {/* <Grid container spacing={2} direction="row"> */}
                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          Effective Date
                        </Typography>
                        <TextField
                          id='txtFldlic_start'
                          name='lic_start'
                          placeholder='Effective Date'
                          value={licStartDt.toISOString().split('T')[0]}
                          onChange={(e) => setLicStartDt(new Date(e.target.value))}
                          fullWidth
                          type={'date'}
                          InputProps={{
                            readOnly: false,
                            sx: { color: text.main },
                            inputProps: { min: 1, max: 200, },
                          }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          Expiration Date
                        </Typography>
                        <TextField
                          id='txtFldlic_end'
                          name='lic_end'
                          placeholder='Expiration Date'
                          value={licEndDt.toISOString().split('T')[0]}
                          onChange={(e) => setLicEndDt(new Date(e.target.value))}
                          fullWidth
                          type={'date'}
                          InputProps={{
                            readOnly: false,
                            sx: { color: text.main }
                          }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={4} md={4} lg={4}>
                        <Typography variant="body2" fontSize={size.xs} justifyContent="center" color={text.main} sx={{ fontWeight: 400, marginBottom: '8px' }} >
                          Notes
                        </Typography>
                        <TextField
                          id='txtFldlic_ref_value'
                          name='lic_ref_value'
                          placeholder='Notes'
                          value={licNote}
                          onChange={handleChange}
                          fullWidth
                          type={'text'}
                          InputProps={{ readOnly: false, sx: { color: text.main }, inputProps: { min: 1, max: 200, }, }}
                          sx={{ color: text.main, borderColor: primary.focus, backgroundColor: transparent.main, borderRadius: borderRadius.md, }}
                          InputLabelProps={{
                            sx: { color: text.main },
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} marginTop={2} justifyContent="flex-end">
                      <Grid item>
                        {(compError) && (
                          <Alert variant="filled" severity="error" onClick={() => setError(undefined)} sx={{ py: 0 }}>
                            <Typography fontSize={size.sm} color={'#fff'} sx={{ fontWeight: 400 }}>{compError}</Typography>
                          </Alert>
                        )}
                      </Grid>
                      <Grid item>
                        <Button onClick={handleConfirmClose} variant="contained" color="secondary" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
                          {isValid ? "Cancel" : "Close"}
                        </Button>&nbsp;
                        <Button type="submit" variant="contained" color="secondary" disabled={!isValid || !enableActionBtn} sx={{ borderRadius: "4px", padding: "10px 20px", }}>
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
}